import CookiesModalController from "../cookiesModal/cookiesModal.controller";

class NavigationController {
  constructor(
    $scope,
    $rootScope,
    $state,
    $interval,
    $sanitize,
    toastr,
    navigationService,
    $stateParams,
    emittentenService,
    $window,
    $uibModal,
    $location
  ) {
    'ngInject';
    this.name = 'navigation';
    this.$rootScope = $rootScope;
    this.$sanitize = $sanitize;
    this.$uibModal = $uibModal;
    this.$interval = $interval;
    this.$location = $location;
    this.$window = $window;
    this.$state = $state;
    this.toastr = toastr;
    this.navigationService = navigationService;
    this.emittentenService = emittentenService;
    $rootScope.$state = $state;
    this.isCollapsed = true;
    this.loginErrorMsg = '';
    this.forgot_password = '';
    this.modalInstance = null;
    this.dev = false;
    this.popover = {
      text: '',
      title: '',
    };

    this.login_email = '';
    this.login_password = '';
    this.lang = 'de';

    if (
      jQuery(location)
        .attr('href')
        .indexOf('/de/') != -1
    ) {
      this.$rootScope.language = 'de';
    } else if (
      jQuery(location)
        .attr('href')
        .indexOf('/en/') != -1
    ) {
      this.$rootScope.language = 'en';
    } else {
      if (jQuery(location).attr('href').indexOf('/teilnehmer') != -1) {
        this.$rootScope.language = 'de';
        this.$location.url('/de/238');
      } else
      if (jQuery(location).attr('href').indexOf('/veranstaltungsort') != -1) {
        this.$rootScope.language = 'de';
        this.$location.url('/de/146');
      } else
      if (jQuery(location).attr('href').indexOf('/participants') != -1) {
        this.$rootScope.language = 'en';
        this.$location.url('/en/151');
      } else
      if (jQuery(location).attr('href').indexOf('/eventvenue') != -1) {
        this.$rootScope.language = 'en';
        this.$location.url('/en/159');
      } else
      if (jQuery(location).attr('href').indexOf('/anmeldung/emittenten') != -1) {
        this.$rootScope.language = 'de';
        this.$location.url('/de/52/54');
      } else
      if (jQuery(location).attr('href').indexOf('/anmeldung/investoren') != -1) {
        this.$rootScope.language = 'de';
        this.$location.url('/de/52/189');
      } else
      if (jQuery(location).attr('href').indexOf('/registration/issuers') != -1) {
        this.$rootScope.language = 'en';
        this.$location.url('/en/76/80');
      } else
      if (jQuery(location).attr('href').indexOf('/registration/investors') != -1) {
        this.$rootScope.language = 'en';
        this.$location.url('/en/52/201');
      } else
      if (jQuery(location).attr('href').indexOf('/start') != -1) {
        this.$rootScope.language = 'de';
        this.$location.url('/de/');
      } else
      if (jQuery(location).attr('href').indexOf('/home') != -1) {
        this.$rootScope.language = 'en';
        this.$location.url('/en/');
      } else {
        this.$rootScope.language = 'de';
        this.$state.go('mainmenu', { id: null, lang: this.$rootScope.language });
      }
    }
    this.getMenu();

    $rootScope.$watch('language', (ch) => {
      if (location.origin.indexOf('eigenkapitalforum.com') === -1) {
        this.dev = true;
      }
      const ca = this.$window.localStorage.getItem('analyticsAccepted');
      if (ca == 'declined') {
        this.clearGA();
      }
      if (ch === 'de') {
        this.loginErrorMsg = 'Login fehlgeschlagen';
        this.forgot_password = 'Passwort vergessen';
        this.cookieMsg = "Auf der Homepage des Deutschen Eigenkapitalforums verwenden wir Cookies und Dienste von Drittanbietern, um die Funktionalität unserer Website sicherzustellen und unser Internet-Angebot zu optimieren." +
          "Über den Button „Akzeptieren“ stimmen Sie zu, dass wir Cookies einsetzen oder Dienste von Drittanbietern nutzen, wie sie in unserer <a href='#/de/203'>Datenschutzerklärung</a> näher beschrieben sind." +
          "Über den Button „Einstellungen“ können Sie der Verwendung der genannten Dienste im Einzelnen zustimmen oder widersprechen.";
        this.cookieCloseBtnText = 'Ablehnen';
        this.cookieAcceptBtnText = 'Akzeptieren';
        this.cookieSettingsBtnText = 'Einstellungen';
      } else {
        this.loginErrorMsg = 'Login failed';
        this.forgot_password = 'Forgot password';
        this.cookieMsg =
          "The Deutsches Eigenkapitalforum website uses cookies and third-party service providers to secure the functionality of " +
          "the website and to optimise our online offering. By clicking the button “I agree”, you allow us to collect " +
          "information and to use third-party services, as explained in our <a href='#/en/202'>privacy policy</a>. " +
          "Using the button “settings”, you can change, accept or recall the use of the services.";
        this.cookieCloseBtnText = 'Decline';
        this.cookieAcceptBtnText = 'Accept';
        this.cookieSettingsBtnText = 'Settings';
      }
      this.lang = ch;
    });

    this.hideCookieMsg = this.$window.localStorage.getItem('cookieContext');

    $scope.$on('CHANGE_LOGO', (event, data) => {
      if ($rootScope.id == undefined) {
        this.id = null;
      } else {
        this.id = $rootScope.id;
      }
    });

    $scope.$on('GET_MENU', (event, data) => {
      // get the mainmenu
      this.getMenu();
    });
  }

  open() {
    this.$rootScope.acceptAnalyticsCookies = window.localStorage.getItem('analyticsAccepted') === 'accepted';
    this.$rootScope.acceptMarketingCookies = window.localStorage.getItem('marketingAccepted') === 'accepted';
    this.modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'myModalContent.html',
      size: 'md',
      controller: CookiesModalController,
      controllerAs: 'vm',
      resolve: {
        lang: () => {
          return this.lang;
        },
        acceptAnalyticsCookies: () => {
          return this.acceptAnalyticsCookies;
        },
        acceptMarketingCookies: () => {
          return this.acceptMarketingCookies;
        }
      }
    });

    this.modalInstance.result.then((res) => {
      if (res.acceptAnalyticsCookies) {
        this.$window.localStorage.setItem('analyticsAccepted', 'accepted');
        window['ga-disable-UA-71073175-2'] = false;
      } else {
        this.$window.localStorage.setItem('analyticsAccepted', 'declined');
        window['ga-disable-UA-71073175-2'] = true;
        this.clearGA();
      }
      if (res.acceptMarketingCookies) {
        this.$window.localStorage.setItem('marketingAccepted', 'accepted');
      } else {
        this.$window.localStorage.setItem('marketingAccepted', 'declined');
        this.clearGA();
      }
      this.hideCookieMsg = 'accepted';
      this.$window.localStorage.setItem('cookieContext', 'accepted');
      window.location.reload();
    });
  };

  acceptCookie() {
    this.hideCookieMsg = 'accepted';
    this.$window.localStorage.setItem('cookieContext', 'accepted');
    this.$window.localStorage.setItem('analyticsAccepted', 'accepted');
    this.$window.localStorage.setItem('marketingAccepted', 'accepted');
    window['ga-disable-UA-71073175-2'] = false;
    window.location.reload();
  }

  declineCookie() {
    this.hideCookieMsg = 'accepted';
    this.$window.localStorage.setItem('cookieContext', 'accepted');
    this.$window.localStorage.setItem('analyticsAccepted', 'declined');
    this.$window.localStorage.setItem('marketingAccepted', 'declined');
    window['ga-disable-UA-71073175-2'] = true;
  }

  getMenu() {
    this.navigationService.getMenu(this.$rootScope.language).then((result) => {
      this.menu = result.data.nav;
      this.metamenu = result.data.footer;
    });
  }

  clearGA() {
    if (window.localStorage.getItem('analyticsAccepted') !== 'accepted') {
      document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=eigenkapitalforum.com;';
      document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=eigenkapitalforum.com;';
      document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=eigenkapitalforum.com;';
    }
  }

  changeLanguage(lang) {
    this.$rootScope.language = lang;
    this.getMenu();
    this.$state.go('mainmenu', { id: null, lang: this.$rootScope.language });
  }

  toggle() {
    jQuery('#navbar').css('height', '500px !important');
    this.isCollapsed = !this.isCollapsed;
  }

  backendLogin() {
    this.emittentenService
      .backendLogin(this.login_email, this.login_password)
      .then(
        (result) => {
          if (result !== false) {
            var email = encodeURIComponent(this.login_email);
            var password = encodeURIComponent(this.login_password);
            var token = encodeURIComponent(result.token);
            window.location =
              this.$rootScope.config.backendLoginUrl + '?token=' + token;
          } else {
            this.toastr.error(this.loginErrorMsg);
          }
        },
        (response) => {
          this.toastr.error(this.loginErrorMsg);
        }
      );
  }

  meetingLogin(){
    let route = this.$rootScope.config.backendLoginUrl + '?meetings=true'
    window.location = route;
  }

  passwordResetUrl() {
    return (
      this.$rootScope.config.backendUrl +
      'passwordreset?email=' +
      encodeURIComponent(this.login_email)
    );
  }
}

export default NavigationController;



// WEBPACK FOOTER //
// ./client/app/common/navigation/navigation.controller.js